var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.4 24 0 18.6 0 12C0 5.4 5.4 0 12 0C18.6 0 24 5.4 24 12C24 18.6 18.6 24 12 24ZM12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18C10.6 18 10.3 17.8 10 17.5C9.5 16.8 9.9 15.8 11 13.1C11.2 12.7 11.4 12.2 11.6 11.8C11.2 12.1 10.6 12.1 10.2 11.7C9.8 11.3 9.8 10.7 10.2 10.3C10.4 10.2 11.6 9 13 9C13.4 9 13.7 9.2 14 9.5C14.5 10.2 14.1 11.2 13 13.9C12.8 14.3 12.6 14.8 12.4 15.2C12.8 14.9 13.4 14.9 13.8 15.3C14.2 15.7 14.2 16.3 13.8 16.7C13.6 16.8 12.4 18 11 18Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8C14.3284 8 15 7.32843 15 6.5C15 5.67157 14.3284 5 13.5 5C12.6716 5 12 5.67157 12 6.5C12 7.32843 12.6716 8 13.5 8Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.5C12.4 8.5 11.5 7.6 11.5 6.5C11.5 5.4 12.4 4.5 13.5 4.5C14.6 4.5 15.5 5.4 15.5 6.5C15.5 7.6 14.6 8.5 13.5 8.5ZM13.5 5.5C12.9 5.5 12.5 5.9 12.5 6.5C12.5 7.1 12.9 7.5 13.5 7.5C14.1 7.5 14.5 7.1 14.5 6.5C14.5 5.9 14.1 5.5 13.5 5.5Z",
    fill: "#6E6E6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.174e2561995f5ffd89126651de262026.svg";
export { ForwardRef as ReactComponent };